module.exports = __webpack_public_path__ + "img/hosp.f9af5f73.png";